import createMutationsSharer from 'vuex-shared-mutations-vue2'

export default ({ store }) => {
  const predicate = ['cart/SET_CART_DATA', 'cart/SET_GUEST_CART_TOKEN', 'currency/SET_ACTIVE_CURRENCY']

  createMutationsSharer({
    predicate,
  })(store)
}
